import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../auth/AuthProvider';
import { getPulseLink, loadPulseTeam, rotatePulseLink } from './pagePulseApi';
export const pulseKeys = { all: ['page-pulse'] as const, link: ['page-pulse', 'link'] as const };
export function usePulseTeam(days: number) {
  const { client } = useAuth();
  return useQuery({
    queryKey: [...pulseKeys.all, days],
    queryFn: () => loadPulseTeam(client, days),
    retry: false,
  });
}
export function usePulseLink(enabled: boolean) {
  const { client } = useAuth();
  return useQuery({
    queryKey: pulseKeys.link,
    queryFn: () => getPulseLink(client),
    retry: false,
    enabled,
  });
}
export function useRotatePulseLink() {
  const { client } = useAuth();
  const query = useQueryClient();
  return useMutation({
    mutationFn: () => rotatePulseLink(client),
    onSuccess: () => void query.invalidateQueries({ queryKey: pulseKeys.link }),
  });
}
